export default class PersonType {
  static MEMBER = 'member';
  static MEMBER_VIEW_ONLY = 'member-view-only';
  static MEMBER_AUTOCOMPLETE = 'member-autocomplete';
  static RECIPIENT = 'recipient';
  static CONTACT = 'contact';
  static CONTACT_AUTOCOMPLETE = 'contact-autocomplete';
}
